export function openPrivacyCenter() {
    window.hc_consent.push("show_modal");
}

export function doConsentAction(action) {
    if (action === "openPrivacyCenter") {
        openPrivacyCenter();
    } else if (action === "declineAllCookies") {
        window.hc_consent.changeConsents({ac:0});
        writeCookiesAndAlertUser(true, true, true);
    } else if (action === "declineAnalyticCookies") {
        window.hc_consent.changeConsents({c1:0});
        writeCookiesAndAlertUser(true, false, false);
    } else if (action === "declinePersonalizationCookies") {
        window.hc_consent.changeConsents({c4:0});
        writeCookiesAndAlertUser(false, true, false);
    } else if (action === "declineMarketingCookies") {
        window.hc_consent.changeConsents({c3:0});
        writeCookiesAndAlertUser(false, false, true);
    }
}


function writeCookiesAndAlertUser(analytics, personalization, marketing) {
    if (analytics) {
        document.cookie ='_con_analytics=0; path=/';
    }
    if (personalization) {
        document.cookie = '_con_personal=0; path=/';
    }
    if (marketing) {
        document.cookie = '_con_marketing=0; path=/';
    }
    alert('Der Widerruf war erfolgreich');
}
